import { Link } from 'gatsby';
import React from 'react';
import bringFriend from '../images/home/help-icons/bring-friend.svg';
import cut from '../images/home/help-icons/cut.svg';
import flex from '../images/home/help-icons/flex.svg';
import freeSignUp from '../images/home/help-icons/free-signup.svg';
import gratis from '../images/home/help-icons/gratis.svg';
import individuality from '../images/home/help-icons/individuality.svg';
import notaxes from '../images/home/help-icons/notaxes.svg';
import portal from '../images/home/help-icons/portal.svg';
import prepay from '../images/home/help-icons/prepay.svg';
import pricedown from '../images/home/help-icons/pricedown.svg';
import sms from '../images/home/help-icons/sms.svg';
import step1 from '../images/home/step-1.svg';
import step2 from '../images/home/step-2.svg';
import step3 from '../images/home/step-3.svg';
import support from '../images/home/help-icons/support.svg';

export default {
	reviews: [
		{
			title: 'Oоо, тези пичове са много добри!',
			comment:
				'За мен скоростта на интернета е водеща, NetSurf задоволяват тази ми нужда на добра цена. За мен е важно да мога да си управлявам оптичния рутер и предоставеният за това интерфейс е доста функционален и лесен за ползване.',
			name: 'Любомир С.',
			initials: 'Л.C.',
			city: 'Вършец'
		},
		{
			title: 'Oоо, тези пичове са много добри!',
			comment:
				'Често забравям да си плащам сметката и удължаването с 1 ден ме спасява да не оставам без услуги, докато си платя на следващия ден.',
			name: 'Борислав Л.',
			initials: 'Б.Л.',
			city: 'Вършец'
		},
		{
			title: 'Oоо, тези пичове са много добри!',
			comment:
				'Броят канали и липсата на проблеми с качеството са причината да избера NetSurf за мой доставчик. Служителите на NetSurf -- както по телефона така и в магазина са много отзивчиви и изключително приятни.',
			name: 'Тодор И.',
			initials: 'Т.И.',
			city: 'Берковица'
		},
		{
			title: 'Oоо, тези пичове са много добри!',
			comment:
				'Мога да връщам назад, не пропускам нито едно любимо предаване. Качеството на сигнала е безупречно.',
			name: 'Стефка М.',
			initials: 'С.М.',
			city: 'Монтана'
		},
		{
			title: 'Oоо, тези пичове са много добри!',
			comment:
				'NetSurf предлагат разнообразие от филмови и спортни канали - така и аз и съпругът ми сме доволни от разнообразието на канали.',
			name: 'Ани П.',
			initials: 'A.П.',
			city: 'Монтана'
		},
		{
			title: 'Oоо, тези пичове са много добри!',
			comment:
				'Голямо семейство сме. Постоянно сме в мрежата, направо я експлоатираме, но няма проблем. Всичко е 6!',
			name: 'Мартин Ц.',
			initials: 'М.Ц.',
			city: 'Оряхово'
		},
		{
			title: 'Oоо, тези пичове са много добри!',
			comment:
				'Обслужването е на високо ниво, посещавам малкото ви магазинче с голямо удоволствие.',
			name: 'Елена Б.',
			initials: 'Е.Б.',
			city: 'Лом'
		},
		{
			title: 'Oоо, тези пичове са много добри!',
			comment:
				'Нуждите ми изискват да имам интернет с висока скорост. Нямам чести прекъсвания и това е супер важно за мен. Възползвам се и от отстъпките за лоялни клиенти. Все пак съм такъв от години.',
			name: 'Нина Н.',
			initials: 'Н.Н.',
			city: 'Лом'
		},
		{
			title: 'Oоо, тези пичове са много добри!',
			comment:
				'Зетят ползва интернета за работа. Би трябвало да е доволен, защото веднъж не се е оплакал от качеството на услугата.',
			name: 'Росица Р.',
			initials: 'Р.Р.',
			city: 'Враца'
		},
		{
			title: 'Oоо, тези пичове са много добри!',
			comment:
				'За мен цената е водеща. Пакетната услуга, която ползвам напълно задоволява нашите семейни нужди за интернет и телевизия.',
			name: 'Калоян П.',
			initials: 'К.П.',
			city: 'Враца'
		}
	],

	forInternet: {
		text:
			'За забавление или по работа, вече ще можеш да правиш онлайн всичко, без да се разсейваш с тревоги за саботажи от времето или тока. NetSurf ти пази плътно гърба с повече от бърз оптичен интернет със скорост за сваляне до 300 Mbit/s с най-новата GPON технология за шампиони, и то при денонощна връзка с нас.',
		list: [
			'Едногодишни и безсрочни договори',
			'Високи интернет скорости до 300 Mbit/s',
			'Безплатен 5GHz Wi-Fi рутер',
			'Свързване чрез непрекъсваема технология (GPON)'
		]
	},

	forTV: {
		text:
			'С интерактивна телевизия от NetSurf гледаш съдържание по вкуса на абсолютно всеки член на домакинството, дори и на кучето и котката, и твоето време е винаги точното време. Ти си програмният директор и обединителят на дома си. Ако пък искаш да гледаш цифрова телевизия на различни платформи, имаш и услугата Multiscreen.',
		list: [
			'Жанрово разнообразие от канали',
			'Постоянно нарастващ брой на каналите',
			'Над 225 канали (над 75+ HD)',
			'Пауза, връщане назад, запис и ТВ архив'
		]
	},

	verticalSteps: [
		{
			title: 'Подбери точния план',
			text:
				'Предлагаме телевизия и интернет за дома, покриващи всеки вкус и бюджет, тъй че само намери своя план и после се свържи с NetSurf да ни го споделиш. Вземи GPON интернет до 300 Mbit/s и най-разнообразни пакети интерактивна телевизия.',
			img: step1
		},
		{
			title: 'Кажи ни удобно време за инсталацията',
			text:
				'С безплатно включване и без такси за оборудване, само в рамките на три работни дни след подписване на договора ще можеш да се радваш на нашите телевизия и интернет услуги. Само направи заявка за ден и час на посещение от наш екип в денонощния ни кол център, в уебсайта ни или в магазинната мрежа.',
			img: step2
		},
		{
			title: 'Наслади се на топ качество телевизия и интернет',
			text:
				'Третата крачка е най-лесната и задоволяващата: вече си готов да се отдадеш на удоволствието от почивката или на плавността на труда си със своя оптимален пакет от телевизия и интернет за дома от NetSurf.',
			img: step3
		}
	],
	faqs: [
		{
			title: 'Какъв е срокът на договора?',
			content: (
				<p className="">
					Предлагаме ти различни варианти на договори: 12 месеца, 24 месеца и
					безсрочни*.
					<br />{' '}
					<small>*Безсрочните договори са само за услугата интернет.</small>
				</p>
			)
		},
		{
			title: 'Каква е цената на пакетната услуга?',
			content: (
				<p className="">
					Предлагаме 3 пакетни услуги и за твое улеснение можеш да си
					конфигурираш и свой собствен. <Link to="/konfigurator/">Виж тук</Link>
					.
				</p>
			)
		},
		// {
		//   title: 'Предлагате ли безжични Wi-Fi рутери?',
		//   content: <p className=''>Да, в по-голяма част от пакети е включен безплатен безжичен оптичен Wi-Fi рутер.</p>,
		// },
		// {
		//   title: 'Предлагате ли Diema Xtra?',
		//   content: <p className=''>Да! Diema Xtra е включен в някои от пакетите ни.</p>,
		// },
		// {
		//   title: 'Предлагате ли MAX Sport?',
		//   content: <p className=''>Да, можеш да се насладиш и на MAX Sport в съответните пакети, в които е включен.</p>,
		// },
		// {
		//   title: 'Може ли да се прекрати договора предсрочно?',
		//   content: <p className=''>Разбира се! За повече информация можеш да се свържете с нас на телефон 088 525 0000 (вътрешен 5) или в магазинната мрежа.</p>,
		// },
		{
			title: 'Променя ли се цената в рамките на договора?',
			content: (
				<p className="">
					Цената може да се промени само в твоя полза (т.е. да стане по-ниска),
					ако се възползваш от някоя от програмите ни за лоялност.
				</p>
			)
		},
		// {
		//   title: 'Предлагаме ли ТВ услуга посредством КА модул?',
		//   content: <p className=''>Ние не предламе телевизия, която да се излъчва посредством КА модул. Телевизионният сигнал се посреща и обработва от телевизионни приемници STB (set-top-box).</p>,
		// },
		{
			title: 'Какви спортни канали предлагате?',
			content: (
				<p className="">
					Списъкът ни е дълъг: Diema Sport, Diema Sport HD, Diema Sport 2, Diema
					Sport 2 HD, TRACE Sport Stars HD, bTV Action, bTV Action HD, RING,
					RING HD, Eurosport, Eurosport HD, Nova Sport, Nova Sport HD, Eurosport
					2, Eurosport 2 HD, AutoMotorSport, AutoMotorSport HD, Fight World HD.
				</p>
			)
		},
		// {
		//   title: 'Какви са параметрите на услугите ви?',
		//   content: <p className=''>Толкова сме гъвкави, в товa което предлагаме, че тук няма да ни стигне мястото да ги опишем. Провери "За Дома" (за дома да е бутон)</p>,
		// },
		{
			title: 'Как се случва окабеляването?',
			content: (
				<>
					<ol>
						<li>Поддаваш заявка и сключваме договор.</li>
						<li>
							След предварителна уговорка, до 3 дни (обикновено по-малко)
							изпращаме технически екип.
						</li>
						<li>
							Следва обстоен оглед на мястото, информираме те как точно ще
							протече окабеляването и откъде ще влязат кабелите в дома ти.
						</li>
						<li>
							Ако имаш допълнителни въпроси, отговаряме и на тях. Уточняваме
							детайлите и преминаваме към инсталация.
						</li>
					</ol>
				</>
			)
		}
		// {
		//   title: 'Ако има изградена вътрешна мрежа, трябва ли кабелите да се подменят?',
		//   content: <p className=''>Не е задължително. Стига мрежата ти да е LAN и да функционира, щом имаш желание можем да ползваме нея.</p>,
		// },
		// {
		//   title: 'Свързаността със сателитни чинии и антени ли е или поредством оптични кабели?',
		//   content: <p className=''>99.9% от мрежата ни е изградена от оптични кабели до сградата или дома на нашите абонати. В отдалечените населени места се използваме специални високоскоростни антени. Сателитни чинии не използваме!</p>,
		// },
		// {
		//   title: 'След изтичане, договорът автоматично ли се подновява?',
		//   content: <p className=''>Не. Ние имаме задачата да те уведомим малко преди договорът ти да изтече и да те запознаем с новите възможности и условия. До подписване на новия договор, ако поради някаква причина се забавим, услугата ти ще бъде преустановена.</p>,
		// },
		// {
		//   title: 'Техническата поддръжка 24/7 ли е?',
		//   content: <p className=''>Да и много се гордеем с това! Телефон 088 525 0000 (вътрешен 9) е на разположение за всякакви технически въпроси 24 часа на ден, 7 дни в седмицата.</p>,
		// },
	],
	helpCards: [
		{
			title: 'Безплатно включване',
			text: 'Не ти струва и стотинка да те свържем.',
			overflow:
				'Ще ти вземем такса само ако трябват над 50 м кабел, ако нямаме 100% покритие на мрежата в твоя район или е нужна комуникационна антена.',
			icon: freeSignUp
		},
		{
			title: 'Без такси за оборудване',
			text:
				'Не плащаш нито едно от нужните устройства за оптичен интернет и цифрова телевизия.',
			overflow: 'Важи само за срока на действие на договора.',
			icon: notaxes
		},
		{
			title: 'Пауза по договор',
			text:
				'Можеш да си спреш нета на срочен абонамент за определено време, без да плащаш периода.',
			overflow: '',
			icon: cut
		},
		{
			title: '5 дни гратисен период',
			text: 'Удължаване на срочния ти абонамент с пет дни след датата за плащане. ',
			overflow: '',
			icon: gratis
		},
		{
			title: '24/7 support по телефона',
			text:
				'Денонощно сме на линия, за да ни докладваш проблем и да го решим скорострелно.',
			overflow: '',
			icon: support
		},
		{
			title: 'Програма „Доведи приятел”',
			text:
				'Привлечи твой човек в NetSurf заедно с теб и получете по 30лв. отстъпка.',
			overflow: '',
			icon: bringFriend
		},
		{
			title: 'Мега яки промоции',
			text: (
				<>
					Обичаш изгодните оферти? Покриваме те! Възползвай се от нашите{' '}
					<a className="text-white text-bold text-underline" href="/promocii/">
						промоции
					</a>{' '}
					по всяко време.
				</>
			),
			overflow: '',
			icon: prepay
		},
		{
			title: 'SMS известяване',
			text:
				'Моментът за плащане на таксата, авария или профилактика, промоция или друго важно събитие - възвестен си на мига.',
			overflow: '',
			icon: sms
		},
		{
			title: 'Активен клиентски портал',
			text: 'Сам управляваш ползваните пакети от нашите услуги.',
			overflow: '',
			icon: portal
		},
		{
			title: 'Компенсации в услугата',
			text:
				'При влошено качество или прекъснат сигнал ще те обезщетим справедливо.',
			overflow: '',
			icon: pricedown
		},
		{
			title: 'Гъвкавост на плащанията',
			text:
				'Става през ePay, EasyPay, NetSurf Play, мобилните банкови приложения, клиентския ни портал и в нашите магазини.',
			overflow: '',
			icon: flex
		}
	]
};

